import {
  Box
} from '@mui/material'

import { useContext } from 'react'

// Context
import { InventoryDataContext, InventoryDispatchContext } from 'src/store/inventory/Store'
import { ItemDataContext } from 'src/store/items/Store'
import { setEquipped, setQuantity } from 'src/store/inventory/actions'

// Components
import ItemBlock from 'src/components/common/ItemBlock'
import { type Equipment } from 'src/types'

const container = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  maxHeight: '40px',
  overflowX: 'scroll'
}

const wrapper = {
  display: 'flex',
  maxWidth: '324px',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '16px'
}

const _Equipment = () => {
  const { inventory } = useContext(InventoryDataContext)
  const { items } = useContext(ItemDataContext)
  const { dispatchInventory } = useContext(InventoryDispatchContext)

  const handleRemoveEquipment = (itemID: string) => {
    // @ts-expect-error
    const item: Equipment = items[itemID]
    setQuantity(dispatchInventory, 'bag', itemID, { '+': 1})
    setEquipped(dispatchInventory, item.slot, itemID, false)
  }

  return (
    <Box sx={container} className="equipment">
      <Box sx={wrapper} className='items'>
        <ItemBlock item={items[inventory.equipped.head]} handleClick={handleRemoveEquipment} defaultLabel='x' color={inventory.equipped.head.length > 0 ? 'gold' : 'gray'}/>
        <ItemBlock item={items[inventory.equipped.chest]} handleClick={handleRemoveEquipment} defaultLabel='x' color={inventory.equipped.chest.length > 0 ? 'gold' : 'gray'}/>
        <ItemBlock item={items[inventory.equipped.hands]} handleClick={handleRemoveEquipment} defaultLabel='x' color={inventory.equipped.hands.length > 0 ? 'gold' : 'gray'}/>
        <ItemBlock item={items[inventory.equipped.feet]} handleClick={handleRemoveEquipment} defaultLabel='x' color={inventory.equipped.feet.length > 0 ? 'gold' : 'gray'}/>
        <ItemBlock item={items[inventory.equipped.bag]} handleClick={handleRemoveEquipment} defaultLabel='x' color={inventory.equipped.bag.length > 0 ? 'gold' : 'gray'}/>
      </Box>
    </Box>
  )
}

export default _Equipment
